module.exports = __webpack_public_path__ + "2235744c95dbf563387e737171d7f6c8.svg";